import type { ListBuilderList } from '../../../types';

/**
 * To Confirm (PD-16227) — active buyers whose only coverage is a suggested
 * match at 90%+ waiting for one click, reached from the Coverage table's per
 * state "To Confirm" count on the Compliance dashboard.
 *
 * Distinct from the Pending Confirmation tab on the Matching screen, which is
 * a match-row queue for the whole tenant: this is the dashboard's own
 * population (a Customer with a sale in the last 90 days) in one state, so the
 * count a reviewer clicked is the count they land on.
 */
export const unconfirmedClientsList: ListBuilderList = {
	id: 'default-licenses-unconfirmed-clients',
	cacheTTL: 300000,
	name: 'To Confirm',
	type: 'default',
	active: true,
	sortOrder: 3,
	filterRules: {
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
			hidden: true,
		},
		licenseClientCoverage: {
			defaultValue: [{ id: 'unconfirmed', label: 'Unconfirmed Match Only' }],
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
